<div class="social-logo">
  <a *ngFor="let social of socials" class="social-link" [href]="social.link" target="_blank">
    <div class="social-item" [inlineSVG]="'assets/images/ismetsocial/' + social.icon"></div>
  </a>
</div>

